import React from "react";
function Route(_props) {
  return /* @__PURE__ */ React.createElement(React.Fragment, null);
}
export {
  Route
};
